export default __webpack_public_path__ + "static/media/Gemi.a8c4c08a.png";